module.exports = __webpack_public_path__ + "img/team-4.53033970.jpg";